import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env, FIRST_PAGE } from '@noor/config';
import {
  businessListSearchSchema,
  businessQueries,
  type BusinessListSearch,
} from '@/entities/business';
import { CuisinesPage } from '@/pages/business';

export const Route = createFileRoute('/business/cuisines')({
  staticData: { permission: 'business.categories.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  validateSearch: businessListSearchSchema,
  loader: ({ context }) => {
    void context.queryClient
      .prefetchQuery(businessQueries.cuisines())
      .catch(() => undefined);
  },
  component: CuisinesRoute,
});

function CuisinesRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const onParamsChange = (next: Partial<BusinessListSearch>) => {
    const resetPage = !('page' in next) && search.page !== FIRST_PAGE;
    void navigate({
      search: (prev) => ({
        ...prev,
        ...next,
        ...(resetPage ? { page: FIRST_PAGE } : {}),
      }),
    });
  };

  return <CuisinesPage params={search} onParamsChange={onParamsChange} />;
}
